import { useEffect, useState } from "react";

import { cancelLinkEdit$, linkDialogState$, removeLink$, updateLink$ } from "@mdxeditor/editor";
import { useCellValues, usePublisher } from "@mdxeditor/gurx";
import { Button, Form, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { SaveButton } from "@/containers/buttons";

export default function TTLinkPlugin() {
  const { t } = useTranslation(["mdxEditor"]);
  const [linkDialogState] = useCellValues(linkDialogState$);
  const updateLink = usePublisher(updateLink$);
  const cancelLinkEdit = usePublisher(cancelLinkEdit$);
  const removeLink = usePublisher(removeLink$);

  const [url, setUrl] = useState("");
  const [title, setTitle] = useState("");

  // Sync state when dialog opens
  useEffect(() => {
    if (linkDialogState.type === "edit") {
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setUrl(linkDialogState.url);
      setTitle(linkDialogState.title);
    }
  }, [linkDialogState]);

  const handleClose = () => {
    cancelLinkEdit();
  };

  const handleSave = () => {
    updateLink({ url, title, text: undefined });
  };

  const handleRemove = () => {
    removeLink();
  };

  return (
    <Modal show={linkDialogState.type === "edit"} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>{t("mdxEditor:linkModal.title")}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form>
          <Form.Group className="mb-3" controlId="link-url">
            <Form.Label>{t("mdxEditor:linkModal.urlLabel")}</Form.Label>
            <Form.Control
              type="text"
              placeholder={t("mdxEditor:linkModal.urlPlaceholder")}
              value={url}
              onChange={(e) => setUrl(e.target.value)}
            />
          </Form.Group>
          <Form.Group className="mb-3" controlId="link-title">
            <Form.Label>{t("mdxEditor:linkModal.textLabel")}</Form.Label>
            <Form.Control
              type="text"
              placeholder={t("mdxEditor:linkModal.textPlaceholder")}
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            />
          </Form.Group>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <SaveButton onClick={handleSave}>{t("translation:global.save")}</SaveButton>

        <Button variant="secondary" onClick={handleClose}>
          {t("translation:global.cancel")}
        </Button>

        <Button variant="danger" onClick={handleRemove}>
          {t("mdxEditor:linkModal.remove")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
